import i18n from '@/utils/i18n';
import React, { useCallback } from 'react';
import { ItemDetailDrawer } from '@/experiences/sales-portal/domain/items/containers/item-detail-drawer';
import { ItemDetailItemInfo } from '@/experiences/sales-portal/domain/items/blocs/types/item-detail-content';
import { PushView } from '@usepepper/sprout-kit-ui';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '@/contexts/theme-context';

interface InsightsMobileItemDetailPushViewProps {
  itemInfo: ItemDetailItemInfo;
  onClose: () => void;
  open: boolean;
  restaurantUUID: string;
  supplierUUID: string;
  timezone: string;
  variantPackUUID: string;
}

export const InsightsMobileItemDetailPushView: React.FC<
  InsightsMobileItemDetailPushViewProps
> = ({
  itemInfo,
  onClose,
  open,
  restaurantUUID,
  supplierUUID,
  timezone,
  variantPackUUID,
}) => {
  const insets = useSafeAreaInsets();
  const theme = useTheme();

  const handleOpenChange = useCallback(
    (next: boolean) => {
      if (!next) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <PushView
      aria-label={i18n.t('insights_hub.item_detail.title')}
      onOpenChange={handleOpenChange}
      open={open}
    >
      <PushView.Header backLabel={i18n.t('back')}>
        <PushView.Title>
          {i18n.t('insights_hub.item_detail.title')}
        </PushView.Title>
      </PushView.Header>
      <PushView.Body padding="$0">
        <ItemDetailDrawer
          bottomInset={insets.bottom + theme.sk.spacing.spaceMedium}
          hideHeaderAction
          itemInfo={itemInfo}
          onClose={onClose}
          restaurantUUID={restaurantUUID}
          supplierUUID={supplierUUID}
          timezone={timezone}
          variantPackUUID={variantPackUUID}
        />
      </PushView.Body>
    </PushView>
  );
};
